import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { FcfaPipe, DateFrPipe, TelMasquePipe, EnumLabelPipe, TaillePipe } from './pipes';
import { BottomSheetComponent } from './bottom-sheet.component';
import { MoneyInputComponent } from './money-input.component';
import { ModePaiementComponent } from './mode-paiement.component';
import { StatusBadgeComponent } from './status-badge.component';
import { EmptyStateComponent } from './empty-state.component';
import { ContactPickerComponent } from './contact-picker.component';
import { DocumentUploaderComponent } from './document-uploader.component';
import { DocumentsLiesComponent } from './documents-lies.component';
import { AuthSrcDirective } from './auth-src.directive';
import { PaiementSheetComponent } from './paiement-sheet.component';
import { ShareSheetComponent } from './share-sheet.component';
import { AjoutRapideComponent } from './ajout-rapide.component';
import { NotificationsComponent } from './notifications.component';
import { AssistantComponent } from './assistant.component';
import { SaisieGroupeeComponent } from './saisie-groupee.component';
import { ActionsCulturesComponent } from './actions-cultures.component';
import { SuppressionGroupeeComponent } from './suppression-groupee.component';
import { BandeauAbonnementComponent } from './bandeau-abonnement.component';
import { CartePhotoComponent } from './carte-photo.component';
import { RecomptageComponent } from './recomptage.component';
import { ReconnaissanceAnimalComponent } from './reconnaissance-animal.component';
import { DicteeComponent } from './dictee.component';
import { PhotosComponent } from './photos.component';
import { EntreeJournalComponent } from './entree-journal.component';
import { ActiviteRecenteComponent } from './activite-recente.component';
import { VisionneuseComponent } from './visionneuse.component';
import { GalerieComponent } from './galerie.component';
import { GalerieSelectionComponent } from './galerie-selecteur';
import { BoutonGalerieComponent } from './bouton-galerie.component';
import { ObservationsComponent } from './observations.component';
import { PeseeEchantillonComponent } from './pesee-echantillon.component';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

const DECLARATIONS = [
  FcfaPipe, DateFrPipe, TelMasquePipe, EnumLabelPipe, TaillePipe,
  BottomSheetComponent, MoneyInputComponent, ModePaiementComponent, StatusBadgeComponent, EmptyStateComponent,
  ContactPickerComponent, DocumentUploaderComponent, DocumentsLiesComponent, AuthSrcDirective, PaiementSheetComponent, ShareSheetComponent,
  AjoutRapideComponent, NotificationsComponent, AssistantComponent, SaisieGroupeeComponent, ActionsCulturesComponent, SuppressionGroupeeComponent, BandeauAbonnementComponent,
  CartePhotoComponent, RecomptageComponent, ReconnaissanceAnimalComponent, DicteeComponent, PhotosComponent,
  EntreeJournalComponent, ActiviteRecenteComponent, VisionneuseComponent, GalerieComponent, GalerieSelectionComponent, BoutonGalerieComponent,
  ObservationsComponent, PeseeEchantillonComponent,
];

/** Composants partagés Bay Sa Waar (Phase 2) : un seul apprentissage pour tous les écrans */
@NgModule({
  declarations: DECLARATIONS,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, NgbModalModule],
  exports: DECLARATIONS,
})
export class BayModule { }
